import SaasHeadManage from "./SaasHeadManage";
import SaasHeadPc from "./SaasHeadPc";

const Index = props => {
  return <>{!props.isShare ? <SaasHeadManage {...props} /> : <SaasHeadPc {...props} />}</>;
};

export default Index;
